import React, { useState, useEffect } from 'react';

const SystemExperienceForm = ({ system, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    category: '',
    title: '',
    icon: '',
    description: ''
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (system) {
      setFormData(system);
    }
  }, [system]);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.category.trim()) {
      newErrors.category = 'Category is required';
    }

    if (!formData.title.trim()) {
      newErrors.title = 'Title is required';
    }

    if (!formData.icon.trim()) {
      newErrors.icon = 'Icon is required';
    }

    if (!formData.description.trim()) {
      newErrors.description = 'Description is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      onSave(formData);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h3>{system ? 'Edit System Experience' : 'Add New System Experience'}</h3>

      <div className="form-group">
        <label htmlFor="category">Category</label>
        <input
          id="category"
          type="text"
          name="category"
          value={formData.category}
          onChange={handleChange}
          placeholder="e.g., Operating Systems"
        />
        {errors.category && <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '5px' }}>{errors.category}</div>}
      </div>

      <div className="form-group">
        <label htmlFor="title">Title</label>
        <input
          id="title"
          type="text"
          name="title"
          value={formData.title}
          onChange={handleChange}
          placeholder="e.g., Linux"
        />
        {errors.title && <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '5px' }}>{errors.title}</div>}
      </div>

      <div className="form-group">
        <label htmlFor="icon">Icon/Emoji</label>
        <input
          id="icon"
          type="text"
          name="icon"
          value={formData.icon}
          onChange={handleChange}
          placeholder="e.g., 🐧 (paste emoji)"
          maxLength="2"
        />
        {errors.icon && <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '5px' }}>{errors.icon}</div>}
      </div>

      <div className="form-group">
        <label htmlFor="description">Description</label>
        <textarea
          id="description"
          name="description"
          value={formData.description}
          onChange={handleChange}
          placeholder="e.g., Experienced in Ubuntu, CentOS, and Debian distributions"
          style={{ width: '100%', padding: '10px', minHeight: '80px', fontFamily: 'inherit', border: '1px solid #ddd', borderRadius: '5px', fontSize: '14px' }}
        />
        {errors.description && <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '5px' }}>{errors.description}</div>}
      </div>

      <div className="modal-actions">
        <button type="button" className="cancel-btn" onClick={onCancel}>
          Cancel
        </button>
        <button type="submit" className="save-btn">
          {system ? 'Update System' : 'Create System'}
        </button>
      </div>
    </form>
  );
};

export default SystemExperienceForm;
